import React from 'react';
import { Icon } from '../Icon/Icon';
export const sizesMapping = {
    120: 64,
    96: 48,
    88: 48,
    80: 48,
    72: 40,
    64: 40,
    56: 28,
    48: 24,
    40: 20,
    32: 20,
    24: 16,
    20: 14,
    16: 12,
};
export const SuperEllipseIcon = ({ size = 64, color, icon, }) => {
    if (!icon) {
        return null;
    }
    return React.createElement(Icon, { name: icon, color: color, size: sizesMapping[size] });
};
